<template lang="html">
  <div class="module">
    <div class="module-left">
      <p class="title">话题类型</p>
      <div>
        <Checkbox
            class="checkAll"
            @on-change="all"
            v-model="is_all"
            :disabled="is_all"
            onclick="_czc.push(['_trackEvent', '机构详情', '话题筛选点击'])"
            >
            <span>全部</span>
        </Checkbox>
        <CheckboxGroup @on-change="single" v-model="params.type">
            <Checkbox
                v-for="(item,index) in news_topic_type"
                :key="index"
                :label="item.id"
                onclick="_czc.push(['_trackEvent', '公司详情', '话题筛选点击'])"
                >
                <span>{{item.name}}</span>
            </Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div class="module-right">
        <div>
          <ul class="news_list">
            <li class="item" v-for="(item1, index1) in newsList" :key="index1">
              <div class="content">
                <div :class="item1.weight > 3 ? 'recommend':''">
                  <a @click="goDetail(item1,'sumary')" onclick="_czc.push(['_trackEvent', '机构详情', '内容查看点击'])">【<span class="tag" v-for="(item3, index3) in item1.type_arr" :key="item3">{{item3 | deal('news_topic_type')}}</span><template v-if="item1.type_arr.length > 0">︱</template>{{item1.title}}】
                  {{item1.content_unsigned}}
                  </a>
                  <span v-if="item1.content_count > 0" class="bd">
                    ({{item1.src_name}}等{{item1.content_count}}家媒体报道)
                  </span>
                </div>
                <div class="div-img" v-if="item1.length!=0">
                  <img :preview="item1.id" v-for="(item3, index3) in item1.file_arr" :key="item3.id" :src="img_req_url + item3.path">
                </div>
                <div class="last-item-row">
                  <div class="tag-list clear">
                    <div class="time">{{item1.create_time | timeTrans}}</div>
                    <div class="entity" v-if="item1.entity.length != 0">
                      <i :class="item1.weight > 3 ? 'recommend iconfont':'iconfont'">&#xe660;</i>
                      <!-- <span v-if="getFirstEntity('0', item1.entity)" >
                        <a :class="item1.weight > 3 ? 'recommend':''"  @click="goEntity('0', item1.entity)">{{getFirstEntity('0', item1.entity).short_name}}</a>
                      </span>
                      <span v-if="getFirstEntity('1', item1.entity)" >
                        <a :class="item1.weight > 3 ? 'recommend':''" @click="goEntity('1', item1.entity)">{{getFirstEntity('1', item1.entity).short_name}}</a>
                      </span> -->
                      <span v-for="item2 in item1.entity" :key="item2.id">
                        <a :class="item1.weight > 3 ? 'recommend':''" @click="goEntity(item2.type, item2.uid)">{{item2.short_name}}</a>
                      </span>
                    </div>
                  </div>
                  <div class="spa">
                    <span>分享至</span>
                    <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item1.uid)" @on-popper-hide="haddleShareHide">
                        <i class="iconfont">&#xe641;</i>
                        <div slot="content" class="share_cnt clear">
                            <div class="share_img"></div>
                            <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                        </div>
                    </Poptip>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <Nothing v-if="newsList.length == 0 && !listLoading">
            <p>没有相关信息</p>
          </Nothing>
          <div class="more" v-else>
              <button @click="changePage" v-if="len == 10 && !listLoading">加载更多</button>
              <p class="no_more" v-if="len < 10 && !listLoading">没有更多内容了</p>
              <Spin fix v-if="listLoading">
                  <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                  <div>Loading</div>
              </Spin>
          </div>
        </div>
    </div>
    <Spin fix v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <OrgModal ref="org_modal" :imgurl="org_modal_img">
      <p class="p1" slot>{{org_modal_p}}</p>
    </OrgModal>
  </div>
</template>

<script>
import { topicList } from '../../../service'
import OrgModal from '@/components/OrgModal.vue'
import Nothing from '@/components/Nothing2'
import { userInfo } from 'js/userInfo'
export default {
  inject: ['login'],
  mixins: [userInfo],
  data() {
    return {
      spinShow: true,
      listLoading: true,
      params: {
        user_key: this.$store.state.user_key,
        entity_uids: [this.$route.params.uid],
        page: 1,
        type: []
      },
      is_all: true,
      newsList: [],
      len: 0,
      org_modal_img: 'cksl',
      org_modal_p: '如果您有需求，可联系我们工作人员'
    }
  },
  components: {
    Nothing,
    OrgModal
  },
  computed: {
    news_topic_type() {
      return this.$store.state.news_topic_type
    },
    img_req_url() {
      return this.$store.state.img_req_url
    },
    topic_read_uids() {
      return this.$store.state.topic_read_uids
    }
  },
  methods: {
    async getDetail() {
      this.listLoading = true
      let res = await topicList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.len = res.res.length
        if (this.params.page == 1) {
          this.$set(this.$data, 'newsList', res.res)
          if(res.res.length > 0) this.$emit('callbackData', 'NewsInfo')
          this.$previewRefresh()
        } else {
          this.newsList = this.newsList.concat(res.res)
        }
        this.listLoading = false
        this.spinShow = false
      } else {
        this.$Message.error(res.msg)
      }
      // this.$nextTick(() => {this.spinShow = false})
    },
    // Ms(time) { // 格式化月份和日期
    //   return moment(time).format('HH:mm')
    // },
    changePage() {
      if (this.user) {
        if (!this.isVIP) {
          if (this.params.page == 2) { // 非会员2页
            this.$refs['org_modal'].goShow()
          } else {
            this.params.page++
            this.getDetail()
          }
        } else {
          if (this.params.page == 10) { // 会员10页
            this.$refs['org_modal'].goShow()
          } else {
            this.params.page++
            this.getDetail()
          }
        }
      } else {
        if (this.params.page < 2) {
          this.params.page++
          this.getDetail()
        } else {
          this.login()
        }
      }
    },
    haddleShare(uid) {
      let share_link = this.$store.state.index2_path+ '/News/newsDetail?uid=' + uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    goDetail(item) {
      if (this.topic_read_uids.indexOf(item.uid) == -1) {
        this.topic_read_uids.push(item.uid)
        this.$store.commit('updateReadList', this.topic_read_uids)
        localStorage.topic_read_uids = JSON.stringify(this.topic_read_uids)
      }
      const href = this.$store.state.index2_path + '/newsDetail/' + item.uid
      window.open(href, '_blank')
    },
    goEntity(type, uid) {
      // let uid = this.getFirstEntity(type, entity).uid
      if (type == '0') {
        const { href } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else {
        const { href } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      }
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    all(is) {
      if (is) {
        this.params.type = []
        this.params.page = 1
        this.getDetail()
      }
    },
    single(arr) {
      this.is_all = (arr.length == 0)
      this.params.page = 1
      this.getDetail()
    },
    getFirstEntity(type, entity) { // 查找第一个实体
      let temp = false
      for (let i of entity) {
        if (i.type == type) {
          temp = i
          break
        }
      }
      return temp
    }
  },
  mounted() {
    //   this.$nextTick(() => {
    //     window.onscroll = () => {
    //       var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
    //       var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //       var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
    //       if(scrollTop > (scrollHeight - windowHeight - 100) && !this.listLoading && scrollTop > 0){
    //         if (this.params.page < 5) {
    //           this.changePage()
    //         }
    //       }   
    //     }
    //   })
  },
  created() {
    this.getDetail()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.module
  display flex
  &-left
    width 160px
    // padding: 0 28px 28px 28px
    border-right 1px solid
    commonBorderColor(#40444F, #E9E9E9)
    > p
      commonBgColor(#2A2F42, #FFFFFF)
      padding 0 28px
      commonColor(#FFFFFF, #333333)
      width 160px
      height 44px
      display table-cell
      vertical-align middle
      font-size 16px
    > div
      padding 20px
      >>>
        label
          font-size 0
          display flex
          &.ivu-checkbox-group-item
            margin-top 10px
          .ivu-checkbox
            font-size 0
            margin-right 8px
            .ivu-checkbox-inner
              margin-top 1px
              display inline-block
              vertical-align top
              background transparent
              commonBorderColor(#7A7F94, #D5D5D5)
            &:hover
              .ivu-checkbox-inner
                commonBorderColor(rgba(250, 122, 80, 1), #23294D)
            &-focus
              box-shadow none
            &.ivu-checkbox-checked
              .ivu-checkbox-inner
                commonBorderColor(rgba(250, 122, 80, 1), #23294D)
                commonBgColor(rgba(250, 122, 80, 1), #23294D)
          span.ivu-checkbox+*
            display inline-block
            line-height 18px
            font-size 13px
            commonColor(#BCBDC1, #333333)
            vertical-align top
            margin 0
            &:hover
              color rgba(250, 122, 80, 1) !important
  &-right
    width -webkit-calc(100% - 160px)
    width -moz-calc(100% - 160px)
    width calc(100% - 160px)
    .reportlist
      padding 32px
      li
        cursor pointer
        .report_cnt
          margin-right 32px
          .describe
            line-height 20px
            -webkit-line-clamp 2
            line-clamp 2
          .info
            margin-top 32px
            .spa2
              line-height 22px
              margin-right 21px
              position relative
              &:before
                content ''
                position absolute
                width 1px
                height 12px
                background-color #d9d9d9
                top 5px
                right -11px
            .spa3
              line-height 22px
              color #999
              i
                font-style inherit
                color $mainColor
                margin 0 !important
.news_list
  commonBgColor(#1f2330, #FFFFFF)
  .item
    display flex
    padding 20px 0
    margin 0 40px
  .item + .item
    border-top 1px dashed
    commonBorderColor(#40444F, #E8E8E8)
  .content
    font-size 14px
    line-height 22px
    flex 3
    .tag
      font-weight 500
    .tag+span
      margin-left 5px
    > div:nth-child(1)
      text-indent -6px
      a
        commonColor(#E9E9EB, #333333)
        &:hover
          color rgba(250, 122, 80, 1) !important
      .bd
        commonColor(#797b83, #999999)
  .div-img
    margin-top 16px
    font-size 0
    line-height 1
    img
      max-width 160px
      max-height 80px
      cursor pointer
    img+img
      margin-left 20px
  .last-item-row
    display flex
    justify-content space-between
    line-height 1
    margin-top 16px
    .tag-list
      text-indent 0 !important
      font-size 12px
      position relative
      .time
        line-height 16px
        commonColor(#BCBDC1, #999999)
        float left
      .entity
        font-size 0
        float left
        margin-left 10px
        padding-left 11px
        position relative
        max-width 650px
        &:before
          content ''
          position absolute
          width 1px
          height 12px
          commonBgColor(#40444f, #D9D9D9)
          top 2px
          left 0
        i
          margin-right 10px
          color rgba(250, 122, 80, 1)
        span
          font-size 12px
          display inline-table
          vertical-align top
          // margin-right 18px
          line-height 16px
          a
            color rgba(250, 122, 80, 1)
            &:hover
              color #FC9C7C
          &+span:before
            content '\B7'
            margin 0 9px
            color #fa7a50
    .spa
      font-size 12px
      position relative
      padding-right 25px
      line-height 16px
      commonColor(#797b83, #999999)
      .iconfont
        font-size 16px
        padding 1px
        line-height 1
        position absolute
        right 0
        top 0
        commonColor(#797b83, #CCCCCC)
        &:hover
          color #63bf61 !important
      & >>> .ivu-poptip
        position absolute
        width 18px
        height 18px
        right 0
        top -1px
        .ivu-poptip-rel
          position absolute
          width 18px
          height 18px
          border-radius 2px
          right 0
          top 0
          cursor pointer
        .ivu-poptip-popper
          transform translate(13px, 0)
          .ivu-poptip-inner
            border-radius 0
            .share_cnt
              padding 10px 20px 10px 10px
              .share_img
                width 80px
                height 80px
                float left
                background #f0f0f0
              p
                line-height 20px
                color #666
                float right
                margin-top 20px
                font-size 14px
.more
  commonBgColor(#1f2330, #FFFFFF)
  padding 25px
  text-align center
  position relative
  min-height 86px
  button
    border 1px solid rgba(250, 122, 80, 1)
    border-radius 18px
    width 108px
    background none
    color rgba(250, 122, 80, 1)
    font-size 14px
    line-height 1
    padding 10px 0
    cursor pointer
    &:hover
      color #FC9C7C
      border-color #FC9C7C
  .no_more
    line-height 36px
    commonColor(rgba(255, 255, 255, 0.6), #999999)
</style>
